import React, { useState, useEffect, useCallback} from 'react';
import PropTypes from 'prop-types';

import { unescapeHtml } from '@ecp/common/src/utils/htmlUtil';
import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import Popup from '@ecp/common/src/components/modal/bo/Popup';
import Editor from '@ecp/common/src/components/editor/Editor';
import poPrivacyPolicy from '@bo-apis/po/system/poPrivacyPolicy';
import  usePoPrivacyPolicyContent  from '@bo-components/po/system/popups/const/poPrivacyPolicyContent';

const PrivacyPolicyPopup = ({ open, onConfirmClick}) => {
  const [privacyPolicy, setPrivacyPolicy] = useState(null);
  
  const [contents, setContents] = useState(null);

  const fetchData = useCallback(
    async () => {
    if(contents === null) {
      const { result } = await poPrivacyPolicy.getLatestPrivacyPolicy();
      setContents(result);
    }
  },[poPrivacyPolicy.getLatestPrivacyPolicy, contents]);

  useEffect(() => {
    fetchData();
  }, [fetchData, setContents ]);  

  const { poPrivacyPolicyContent } = usePoPrivacyPolicyContent( contents );

  useEffect(() => {
    if (open) {
      setPrivacyPolicy(poPrivacyPolicyContent[0]?.value);
    }
  }, [open]);  

  const handleSelect = (e) => {
    setPrivacyPolicy(poPrivacyPolicyContent[e.target.value].value); 
  };

  return (
    <Popup
      type={'Medium'}
      open={open}
      header={'개인정보처리방침'}
      useCancelButton={false}
      onConfirmClick={onConfirmClick}
      onClose={onConfirmClick}
    >
      <FlexBoxColumn>
        <FlexBoxColumn align-items={'flex-end'} width={'620px'}>
          <select onChange={handleSelect}>
            {poPrivacyPolicyContent?.map((item, index) => (
              <option value={index} key={item.key}>
                {item.label}
              </option>
            ))}
          </select>
        </FlexBoxColumn>
        <Spacing top={10} />
        <FlexBoxColumn>
          <Editor readonly html={unescapeHtml(privacyPolicy)} backgroundColor={'#F8F8FA'} />
        </FlexBoxColumn>
      </FlexBoxColumn>
    </Popup>
  );
};

export default PrivacyPolicyPopup;

PrivacyPolicyPopup.propTypes = {
  open: PropTypes.bool,
  onConfirmClick: PropTypes.func,
};
